import React, { useState } from 'react';
import { connect } from 'react-redux';

import AccountLinkingScreen from 'apps/auth/components/ga/cards/order/AccountLinkingScreen';
import BasePage from 'apps/auth/components/utils/BasePage';
import ModalWithTimer from 'apps/auth/components/utils/ModalWithTimer';
import { AUTH_GA_CARD } from 'apps/auth/constants/UrlConstants';
import { LINK, SUCCESS } from 'apps/auth/services/GaCardsService';

const GetVirtualPage = (props) => {
    const [screen, setScreen] = useState(LINK);
    const onClickSuccess = () => {
        window.location.href = AUTH_GA_CARD + props.card?.id;
    };

    if (screen === LINK) {
        return (
            <AccountLinkingScreen
                title={props.virtualLinkTitle}
                subTitle={props.virtualLinkText}
                isPurple={false}
                cardText={props.virtual}
                accounts={props.accounts}
                setScreenSuccess={() => setScreen(SUCCESS)}
                url={`${AUTH_GA_CARD}get/virtual/`}
            />
        );
    }
    if (screen === SUCCESS) {
        return <ModalWithTimer text={props.messageCardLinked} onClick={onClickSuccess} />;
    }
    return null;
};
const mapStateToProps = (state) => ({
    accounts: state.extra.accounts,
    card: state.extra.card,
    virtualLinkTitle: state.messages.pageMessages.virtualLinkTitle,
    virtualLinkText: state.messages.pageMessages.virtualLinkText,
    virtual: state.messages.pageMessages.virtual.toLowerCase(),
    messageCardLinked: state.messages.pageMessages.messageCardLinked,
});
export default connect(mapStateToProps, null)(BasePage(GetVirtualPage));
